<template lang="html">
  <pl-dialog
    :title="'Polls'"
    :size="'md'"
    :disableOutsideClick="true"
    @close="$emit('close')"
  >
    <template v-if="showPage && !show_poll">
      <body class="px-7 py-4 flex-grow overflow-y-auto">
        <div v-if="hasTeacherPermissionsInCourse">
          <div v-for="(poll, index) in discussion_polls" class="sample ellipsis-text w-full border rounded h-12 px-3 mb-2 flex items-center justify-between cursor-pointer hover:bg-gray-100" @click="selectPoll(poll.id)">
            <p :class="{'text-gray-400':poll.status === 'draft'}">{{ poll.question || `poll #${index + 1}` }}</p>
            <span v-if="poll.status === 'draft'" class="text-xs text-gray-400">draft</span>
            <span v-else class="text-xs">{{poll.votes.length}} votes</span>
          </div>
        </div>
        <div v-else>
          <div v-if="!discussion_polls.filter((p) => p.status === 'live').length" class="text-center">
            <p class="font-semibold pb-4">There are no polls to display yet.</p>
            <p>Your teacher can create a poll on any topic and students can vote!</p>
          </div>
          <div v-else>
            <div v-for="(poll, index) in discussion_polls.filter((p) => p.status === 'live')" class="sample ellipsis-text w-full border rounded h-12 px-3 mb-2 flex items-center justify-between cursor-pointer hover:bg-gray-100" @click="selectPoll(poll.id)">
              <p>{{ poll.question || `poll #${index + 1}` }}</p>
              <i
                v-if="getPollVoters(poll).includes(getProfile.id)"
                class="fas fa-check-circle text-primary"
                title="Answered"
              />
              <i
                v-else="getPollVoters(poll).includes(getProfile.id)"
                class="far fa-clock text-gray-400"
                title="Unanswered"
              />
            </div>
          </div>
        </div>
      </body>
      <footer
        v-if="hasTeacherPermissionsInCourse"
        class="flex px-7 py-5 text-center justify-center items-center"
      >
        <button
          v-if="hasTeacherPermissionsInCourse"
          class="sample text-white center justify-center w-40 py-2 bg-primary rounded cursor-pointer font-semibold"
          @click="createNewPoll"
        >
          <strong>New</strong>
        </button>
      </footer>
    </template>
  </pl-dialog>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Create from './polls.create';
  import Vote from './polls.vote';
  import Results from './polls.results';
  import find from 'lodash/find';
  import findIndex from 'lodash/findIndex';
  import { EventBus } from 'utils/event-bus';
  import PlDialog from '../../components/material/components/plDialog/plDialog.vue';
  export default {
    data() {
      return {
        loading_poll: false,
        selected_poll_id: '',
        show_poll: false,
        question: '',
      };
    },
    props: {
      showPage: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Create,
      Vote,
      Results,
      PlDialog,
    },
    computed: {
      ...mapGetters([
        'getCurrentDiscussion',
        'hasTeacherPermissionsInCourse',
        'getProfile',
      ]),
      discussion_polls() {
        return this.getCurrentDiscussion.polls;
      },
      selected_poll() {
        return find(this.getCurrentDiscussion.polls, {
          id: this.selected_poll_id,
        });
      },
      poll_page() {
        const poll = this.selected_poll;
        const author = this.hasTeacherPermissionsInCourse;
        let page;
        if (poll && author) {
          page = poll.status === 'live' ? 'results' : 'create';
        } else {
          page = this.user_already_voted ? 'results' : 'vote';
        }
        return page;
      },
      user_already_voted() {
        return this.selected_poll
          ? findIndex(this.selected_poll.votes, {
              user_id: this.getProfile.id,
            }) !== -1
          : false;
      },
    },
    methods: {
      getAllPolls() {
        if (this.getCurrentDiscussion.id) {
          this.$store.dispatch('getAllPolls', this.getCurrentDiscussion.id);
        }
      },
      getPollVoters(poll) {
        return poll.votes.map((v) => v.user_id);
      },
      // TODO: make this actually work

      // Create a new poll - Teacher only
      createNewPoll() {
        this.$store
          .dispatch('createPoll', {
            answers: this.answers,
            status: 'draft',
            question: this.question,
            discussion_id: this.getCurrentDiscussion.id,
          })
          .then((poll) => {
            EventBus.$emit('show_poll', {
              show_poll: true,
              selected_poll_id: poll.id,
            });
          });
      },
      // Open a pre-existing poll
      selectPoll(pollID) {
        EventBus.$emit('show_poll', {
          show_poll: true,
          selected_poll_id: pollID,
        });
      },
    },
    mounted() {
      this.getAllPolls();
      this.unwatchCurrentDiscussionID = this.$watch(
        'getCurrentDiscussion.id',
        () => {
          this.getAllPolls();
        }
      );
    },
    beforeDestroy() {
      this.unwatchCurrentDiscussionID();
    },
  };
</script>



// WEBPACK FOOTER //
// polls.index.vue?01656e4b